import React from 'react'

const Profile = React.lazy(() => import('./Profile'))

export default Profile
